// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'fr': 'fr-BE', 'nl': 'nl-BE'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#dfdfdf",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "BE",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Belgium", "code": "BE", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": true}, "Nederlands": {"name": "Nederlands (Dutch)", "native_name": "Nederlands", "code": "nl", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        